import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

const TOKEN_KEY = "litterantara_token";
export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (t) => localStorage.setItem(TOKEN_KEY, t);
export const clearToken = () => localStorage.removeItem(TOKEN_KEY);

// Attach bearer token to every request when present
api.interceptors.request.use((config) => {
  const token = getToken();
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const submitConsultation = async (payload) => {
  const { data } = await api.post("/consultations", payload);
  return data;
};

// ---- Auth ----
export const loginRequest = async (email, password) => {
  const { data } = await api.post("/auth/login", { email, password });
  return data;
};

export const fetchMe = async () => {
  const { data } = await api.get("/auth/me");
  return data;
};

// ---- Admin: leads ----
export const fetchLeads = async (status) => {
  const { data } = await api.get("/consultations", {
    params: status && status !== "all" ? { status } : {},
  });
  return data;
};

export const fetchStats = async () => {
  const { data } = await api.get("/consultations/stats");
  return data;
};

export const updateLeadStatus = async (id, status) => {
  const { data } = await api.patch(`/consultations/${id}/status`, { status });
  return data;
};

// ---- Articles / Insights ----
export const fetchArticles = async (category) => {
  const { data } = await api.get("/articles", {
    params: category && category !== "all" ? { category } : {},
  });
  return data;
};

export const fetchArticle = async (slug) => {
  const { data } = await api.get(`/articles/${slug}`);
  return data;
};

export const createArticle = async (payload) => {
  const { data } = await api.post("/articles", payload);
  return data;
};

export const deleteArticle = async (slug) => {
  await api.delete(`/articles/${slug}`);
};
